import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { ensureAppCheck } from '../firebase-config';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const { authLoading, isAuthenticated, isAdmin } = useAuth();

    useEffect(() => {
        if (isAuthenticated) {
            ensureAppCheck();
        }
    }, [isAuthenticated]);

    if (authLoading) {
        return <div className='admin-status-message'>Checking admin access...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to='/admin/login' replace state={{ from: location }} />;
    }

    if (!isAdmin) {
        return <Navigate to='/admin/login' replace state={{ unauthorized: true }} />;
    }

    return children;
};

export default ProtectedRoute;
